import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { hideModal as hideModalAction, MODAL_TYPE_PRO_MYPAGE_DELETE, } from '../../../../../actions/ModalActions';
import { API_DELETE_PROFESSIONAL_SOLUTION, apiDeleteProfessionalSolution, } from '../../../../../actions/ProfessionalSolutionActions';
import { propBool, propFunc, propShape, } from '../../../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../../../helpers/fetch';
import { getModalValue } from '../../../../../helpers/modal';
import Modal from '../../../../Ui/Modal';
import ModalDeleteSolutionMain from './Content/ModalDeleteSolutionMain';
// noinspection RequiredAttributes
const ModalDeleteSolution = ({ handleSubmit, isLoading, solution }) => (_jsx(Modal, Object.assign({ isLoading: isLoading, modalType: MODAL_TYPE_PRO_MYPAGE_DELETE }, { children: _jsx(ModalDeleteSolutionMain, { handleSubmit: handleSubmit, isLoading: isLoading, solution: solution }) })));
ModalDeleteSolution.propTypes = {
    handleSubmit: propFunc().isRequired,
    isLoading: propBool().isRequired,
    solution: propShape(),
};
ModalDeleteSolution.defaultProps = {
    solution: null,
};
const mapStateToProps = ({ fetch, modal }) => {
    const { item: { solution }, } = getModalValue(modal, MODAL_TYPE_PRO_MYPAGE_DELETE);
    return {
        isLoading: isLoadingApis(fetch, API_DELETE_PROFESSIONAL_SOLUTION),
        solution,
    };
};
const mapDispatchToProps = (dispatch) => ({
    handleSubmit: (id) => {
        dispatch(apiDeleteProfessionalSolution(id, {
            resolve: hideModalAction(MODAL_TYPE_PRO_MYPAGE_DELETE),
        }));
    },
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(ModalDeleteSolution);
